module.exports = __webpack_public_path__ + "media/components/country-flag/static/gy-8e778f9f637df8dd6e9de712e552c314.svg";